import React, { Component } from 'react';
import {
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  InputGroup,
  Row,
  Col,
} from 'reactstrap';
import Draggable from 'react-draggable';

import { FetchData } from './utils/DataFetch';
import { GetCookie } from './utils/Common';

import { WorkOrderFormSearchTableDefault } from './WorkOrderFormSearchTableDefault';

export class WorkOrderFormSearch extends Component {
  static displayName = WorkOrderFormSearch.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      workOrderList: [],
      deltaPosition: { x: 0, y: 0 },
      searchModel: {
        JobNum: props.JobNum || null,
        StartDate: '',
        EndDate: '',
        Claimant: '',
        ClmClaimNumberNoDash: '',
        CLMPhone: '',
        Interpreter: '',
        Rep: '',
        ClientAbbrv: '',
        ProviderName: '',
        IntId: '',
        ClmId: '',
        CreatedByUserId: null,
        MyJobs: false,
        MyJobsUserId: null,
        WorkFlowId: '',
      },
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDoubleClick = this.handleDoubleClick.bind(this);

    this.jobNumRef = React.createRef();

    if (props.JobNum) this.populateWorkOrderData();
  }

  componentDidMount() {
    setTimeout(() => {
      if (this.jobNumRef.current) {
        this.jobNumRef.current.focus();
      }
    }, 100);
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  handleChange(e) {
    let model = { ...this.state.searchModel };
    if (e.target.name === 'JobNum') {
      model[e.target.name] =
        e.target.value !== '' ? parseFloat(e.target.value) : null;
    } else {
      model[e.target.name] = e.target.value;
    }
    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.populateWorkOrderData();
    }
  }

  handleDoubleClick(event) {
    const workorder = event.data;
    this.props.handleDoubleClick({
      JobId: workorder.jobId,
      JobNum: workorder.jobNum,
      ClientId: workorder.clientId || null,
      ClientName: workorder.clientName || '',
      ClientAbbrv: workorder.clientAbbrv || '',
      ClaimantId: workorder.clmId || null,
      ClmFirstName: workorder.clmFirstName || '',
      ClmLastName: workorder.clmLastName || '',
      RepId: workorder.repId || null,
      RepFirstName: workorder.repFirstName || '',
      RepLastName: workorder.repLastName || '',
      IntId: workorder.intId || null,
      IntFirstName: workorder.intFirstName || '',
      IntLastName: workorder.intLastName || '',
      ProvId: workorder.provId || null,
      ProviderName: workorder.providerName || '',
    });
  }

  async populateWorkOrderData() {
    let searchModel = { ...this.state.searchModel };
    if (searchModel.JobNum === '') searchModel.JobNum = null;

    await FetchData(
      '/getworkorders',
      'POST',
      this.user.token,
      searchModel
    ).then((data) => {
      if (Array.isArray(data)) {
        this.setState({ workOrderList: data, loading: false });
      } else {
        this.setState({ workOrderList: [], loading: false });
      }
    });
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition = { x: 0, y: 0 } } = this.state || {};

    return (
      <Draggable
        handle=".workorder-form-search-handle"
        onDrag={this.handleDrag}
        {...dragHandlers}
      >
        <div style={{ height: '400px' }}>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              width: '1000px',
              maxWidth: '1000px',
            }}
            backdrop="static"
          >
            <ModalHeader className="workorder-form-search-handle handle">
              <span style={{ fontSize: '14px' }}>Search Work Order</span>
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <InputGroup size="sm">
                      <input
                        name="JobNum"
                        type="number"
                        className="form-control form-control-text"
                        value={this.state.searchModel.JobNum || ''}
                        onChange={this.handleChange}
                        ref={this.jobNumRef}
                        placeholder="Job #"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="StartDate"
                        type="date"
                        max="9999-12-31"
                        className="form-control form-control-text"
                        value={this.state.searchModel.StartDate || ''}
                        onChange={this.handleChange}
                        placeholder="Start Date"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="EndDate"
                        type="date"
                        max="9999-12-31"
                        className="form-control form-control-text"
                        value={this.state.searchModel.EndDate || ''}
                        onChange={this.handleChange}
                        placeholder="End Date"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="Claimant"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.Claimant || ''}
                        onChange={this.handleChange}
                        placeholder="Claimant"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="ClmClaimNumberNoDash"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.ClmClaimNumberNoDash || ''}
                        onChange={this.handleChange}
                        placeholder="Claimant #"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="CLMPhone"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.CLMPhone || ''}
                        onChange={this.handleChange}
                        placeholder="CLM Phone"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="Interpreter"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.Interpreter || ''}
                        onChange={this.handleChange}
                        placeholder="Interpreter"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="Rep"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.Rep || ''}
                        onChange={this.handleChange}
                        placeholder="Rep"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="ClientAbbrv"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.ClientAbbrv || ''}
                        onChange={this.handleChange}
                        placeholder="Client Abbrv"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="ProviderName"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.ProviderName || ''}
                        onChange={this.handleChange}
                        placeholder="Job Provider"
                        onKeyDown={this.handleKeyDown}
                      />
                      <Button
                        color="primary"
                        size="sm"
                        onClick={() => this.populateWorkOrderData()}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        Search
                      </Button>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <WorkOrderFormSearchTableDefault
                      workOrderList={this.state.workOrderList}
                      handleDoubleClick={this.handleDoubleClick}
                    />
                  </Col>
                </Row>
              </div>
            </ModalBody>
          </Modal>
        </div>
      </Draggable>
    );
  }
}
